import { useQuery } from "react-query";
import { getAgencyMapping } from "../../../../../actions/Utilities/AgencyMapping";

export const useGetAgencyMapping = () => {
  return useQuery("GetAgencyMapping", getAgencyMapping, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
